const addHours = (date: Date, hours: number) => {
  const copy = new Date(Number(date));
  copy.setTime(date.getTime() + hours * 60 * 60 * 1000);
  return copy;
};

export default addHours;
